import React from "react";
import { useHistory } from "react-router-dom";
import { CommandBarButton } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../core/security/SprintAccessRight";
import { ciCreateFileRecordFormRoute } from "../../../../ContentIngestionRoutes";

export const CreateFileRecordButton: React.FC = () => {
    const history = useHistory();

    const handleClick = () => {
        history.push(ciCreateFileRecordFormRoute.path);
    };

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.CiReadWrite]}>
            <CommandBarButton
                onClick={handleClick}
                text="Add"
                icon="Add"
                testId="add-file-record-button"
                disabled={false}
            />
        </AuthorizationWrapper>
    );
};
